import { createFileRoute } from '@tanstack/react-router';
import { ProjectDetailPage } from '@/features/projects/ui/ProjectDetailPage';

export const Route = createFileRoute('/_authenticated/projects/$code')({
  component: function ProjectDetailRoute() {
    const { code } = Route.useParams();
    return <ProjectDetailPage code={code} />;
  },
});
